<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="p-1">
                        <form class="" @submit.prevent="submitForm">
                            <div class="row">
                                <div class="form-group col-12 col-md-3">
                                    <label for="phone24">Tipo de instalación:</label>
                                    <b-form-input v-model="typology.description" autocomplete="off"/>
                                    <span v-if="validation_typology.description" class="text-danger">
                                      {{ validation_typology.description }}
                                    </span>
                                </div>
                                <div class="form-group col-12 col-md-3">
                                  <label for="phone24">Tipología:</label>
                                  <b-form-input v-model="typology.name" autocomplete="off"/>
                                  <span v-if="validation_typology.name" class="text-danger">
                                        {{ validation_typology.name }}
                                      </span>
                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR_INSTALLATIONTYPES_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
    getterType: 'installationTypes/getField',
    mutationType: 'installationTypes/updateField',
})

export default {
    name: "FormView",
    components: {
        BCol,
        BRow,
        BCard,
        BFormInput,
        BOverlay,
    },
    data() {
        return {
            edit: false,
            showLoading: false,
            typologiesList: [],
        }
    },
    computed: {
        ...mapState('typologies', ['typology', 'validation_typology']),
        ...mapFields({
            installation_type: 'typology',
        }),
    },
    created() {
        this.$store.commit('typologies/RESET_STATE')
        this.$store.commit('typologies/CLEAR_VALIDATION')
        if (this.$route.params.id) {
            this.edit = true
            this.findTypology()
        } else {
            this.edit = false
        }
        this.$root.$refs.auxiliariesTypologiesForm = this
    },
    methods: {
      findTypology() {
            this.showLoading = true

            this.$store.dispatch('typologies/findTypology',
                this.$route.params.id ?? this.typology.id
            )
                .then(response => {
                  this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(GEI_AUXILIAR_INSTALLATIONTYPES_LIST)
        },
        createAuxiliar() {
            this.$store.dispatch('typologies/createTypology', this.typology)
                .then(response => {
                    helper.showToast('Tipo de instalación creado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_INSTALLATIONTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al crear tipo de instalación', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        updateAuxiliar() {
            this.$store.dispatch('typologies/updateTypology', this.typology)
                .then(response => {
                    helper.showToast('Tipo de instalación editado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_INSTALLATIONTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al editar tipo de instalación', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        submitForm() {
            if (this.$route.params.id) {
                this.updateAuxiliar()
            } else {
                this.createAuxiliar()
            }
        },
    },
}
</script>
